import {
  Box,
  Checkbox,
  Chip,
  Collapse,
  FormControlLabel,
  FormGroup,
  List,
  ListItemButton,
  ListSubheader,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { MdClear } from "react-icons/md";
import ExamTable from "../examTips/ExamTable";
import QuestionTable from "./QuestionTable";
import { useDispatch, useSelector } from "react-redux";
import { ieltsCourseManagmentQuestionBankFindAction, ieltsQuestionBankFilterAction } from "../../../../actions/IeltsActions/courseManagmentAction";
import IeltsFilter from "../examTips/ExamFilter";

function QuestionBankMain({subMenu}) {
  const dispatch = useDispatch();
  const [questionbankList, setQuestionBankList] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);

  let {
    ieltsCourseManagmentQuestionBankFindSuccess,
    ieltsCourseManagmentQuestionBankFinderror,
  } = useSelector((state) => {
    return state.ieltsCourseManagmentQuestionBankFind;
  });
  let {
    ieltsCourseManagmentQuestionBankCreateSuccess,
    ieltsCourseManagmentQuestionBankCreateerror,
  } = useSelector((state) => {
    return state.ieltsCourseManagmentQuestionBankCreate;
  });

  let {
    ieltsCourseManagmentQuestionBankStatusSuccess,
    ieltsCourseManagmentQuestionBankStatuserror,
  } = useSelector((state) => {
    return state.ieltsCourseManagmentQuestionBankStatusChange;
  });

  let {
    ieltsCourseManagmentQuestionBankDeleteSuccess,
    ieltsCourseManagmentQuestionBankDeleteerror,
  } = useSelector((state) => {
    return state.ieltsCourseManagmentQuestionBankDelete;
  });

  let {
    ieltsCourseManagmentQuestionBankUpdateSuccess,
    ieltsCourseManagmentQuestionBankUpdateerror,
  } = useSelector((state) => {
    return state.ieltsCourseManagmentQuestionBankUpdate;
  });

  const { ieltsQuestionBankFilterSuccess } = useSelector((state) => state.ieltsQuestionBankFilterFind)

  useEffect(() => {
    dispatch(ieltsCourseManagmentQuestionBankFindAction());
  }, [
    dispatch,
    ieltsCourseManagmentQuestionBankStatusSuccess,
    ieltsCourseManagmentQuestionBankCreateSuccess,
    ieltsCourseManagmentQuestionBankDeleteSuccess,
    ieltsCourseManagmentQuestionBankUpdateSuccess,
  ]);

  useEffect(() => {
    if (ieltsCourseManagmentQuestionBankFindSuccess) {
      setQuestionBankList(ieltsCourseManagmentQuestionBankFindSuccess?.data);
    }
  }, [dispatch, ieltsCourseManagmentQuestionBankFindSuccess]);

  useEffect(() => {
    if(ieltsQuestionBankFilterSuccess) {
      setQuestionBankList(ieltsQuestionBankFilterSuccess?.data)
    }
  }, [dispatch, ieltsQuestionBankFilterSuccess])

  const columns = [
    { title: "SL NO", field: "sl" },
    { title: "TOPIC NAME", field: "topic name" },
    { title: "CATEGORY", field: "category Name" },
    { title: "STATUS", field: "status" },
  ];

  const [secListopen, setSecListOpen] = useState(true);
  const [selectedCountry, setSelectedCountry] = useState(null);

  const [categoryList, setCategoyList] = useState([
    "Listening",
    "Reading",
    "Speaking",
    "Writing",
    "Grammar",
    "Exam Tips",
    "Question Bank",
  ]);

  // handleFilter function

  const handleFilterFunction = (filterValue, checkedStatus) => {
    setSelectedCategory(filterValue === selectedCategory ? null : filterValue);
    if (checkedStatus) {
      setQuestionBankList(
        ieltsCourseManagmentQuestionBankFindSuccess?.data?.filter(
          (topics, index) => {
            return filterValue == topics.category;
          }
        )
      );
    } else {
      setQuestionBankList(ieltsCourseManagmentQuestionBankFindSuccess.data);
    }
  };

  // Handle ClearAll function

  const handleClearAllFunction = () => {
    setQuestionBankList(ieltsCourseManagmentQuestionBankFindSuccess?.data);
    setSelectedCategory(null);
  };

  const handleClick2 = () => {
    setSecListOpen(!secListopen);
  };

  const [ids, setIds] = useState([]);

  const selectBoxIdPassHandler = (ids) => {
    setIds(ids);
  };



  const [page, setPage] = useState(10);
  const [pageError, setPageError] = useState("");

  const handlePageSearch = (e) => {
    const { value } = e.target;
    if (value >= 0) {
      setPage(value);
    }
    if (value >= 10) {
      setPageError("");
    } else {
      setPageError("please choose a value greater than 10");
    }
  };

  const leadFilterFunction = (filterData) => {
    try {
      dispatch(ieltsQuestionBankFilterAction(filterData))
    } catch(error) {
      console.error(error);
    }
  }

  return (
    <>
      <Box
        sx={{
          mt: 2,
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr",
            lg: "330px 1fr",
          },
          gap: "25px",
        }}
      >
        <Box>
          {selectedCategory && <Chip
            sx={{
              "&.MuiChip-root": {
                pl: "5px",
                pr: "5px",
              },
            }}
            label={
              <Typography
                sx={{
                  fontSize: "10px",
                  fontWeight: "700",
                  color: "rgba(88, 94, 106, 1)",
                }}
              >
                Category:{" "}
                <Typography
                  sx={{
                    fontSize: "10px",
                    fontWeight: "400",
                  }}
                  component={"span"}
                >
                  {selectedCategory}
                </Typography>
              </Typography>
            }
            onDelete={handleClearAllFunction}
          />
          }

          <IeltsFilter
            leadFilterFunction={leadFilterFunction}
            componentName="questionBank"
          />
        </Box>

        <QuestionTable
          data={questionbankList}
          columns={columns}
          component="questionBank"
          selectBoxIdPassHandler={selectBoxIdPassHandler}
          pageNumber={page}
          subMenu={subMenu}
        />
      </Box>
    </>
  );
}

export default QuestionBankMain;
